import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';

interface IGetInnerGamesIds {
  serviceId: number;
  limit?: number;
}

interface IPlatformData {
  provider_game_id: string;
  enabled: boolean;
  has_demo: boolean;
  extra_data: Record<string, unknown>;
}

export interface IGameDetails {
  enabled: boolean;
  extra_data: Record<string, unknown>;
  game_id: number;
  game_list: number[];
  game_name: string;
  has_freespin: boolean;
  platform: {
    desktop: IPlatformData;
    mobile: IPlatformData;
    android: IPlatformData;
    ios: IPlatformData;
  };
  providerId: number;
}

interface IGetInnerGamesIdsResponse {
  data: {
    games: IGameDetails[];
  };
}

export const getInnerGamesIds = ({
  serviceId,
  limit = 300
}: IGetInnerGamesIds) => {
  return get<IGetInnerGamesIdsResponse>(
    `/service/GM/api/providers/${serviceId}/games?limit=${limit}`
  ).then((res) => camelizeKeys<IGetInnerGamesIdsResponse>(res));
};
